import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import FeatherIcon from "feather-icons-react";

import CompanyAddressEditor from "./components/CompanyAddressEditor";

import { useGetCurrentCompanySettings } from "@api";
import { Box, Button, Card, Stack, Typography } from "@components/base";
import { useUserStore } from "@store/user";

const CompanyAddress: FC = () => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const [editAddressOpen, setEditAddressOpen] = useState(false);
  const { currentCompanySettings, currentCompanySettingsEnabled } =
    useGetCurrentCompanySettings(user);
  const hasAddress =
    currentCompanySettings?.registeredAddress?.address ||
    currentCompanySettings?.registeredAddress?.city ||
    currentCompanySettings?.registeredAddress?.zip ||
    currentCompanySettings?.registeredAddress?.country;

  return currentCompanySettingsEnabled && currentCompanySettings ? (
    <>
      {hasAddress && (
        <Card>
          <Stack spacing={2} p={2}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="body2">
                {t("organizationSettings.companyAddress.address")}
              </Typography>
              <Typography fontWeight={600}>
                {currentCompanySettings.registeredAddress?.address}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="body2">
                {t("organizationSettings.companyAddress.city")}
              </Typography>
              <Typography fontWeight={600}>
                {currentCompanySettings.registeredAddress?.city}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="body2">
                {t("organizationSettings.companyAddress.zip")}
              </Typography>
              <Typography fontWeight={600}>
                {currentCompanySettings.registeredAddress?.zip}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Typography variant="body2">
                {t("organizationSettings.companyAddress.country")}
              </Typography>
              <Typography fontWeight={600}>
                {currentCompanySettings.registeredAddress?.country}
              </Typography>
            </Stack>
          </Stack>
        </Card>
      )}
      <Box mt={hasAddress ? 2 : 0}>
        <Button
          variant="outlined"
          onClick={() => setEditAddressOpen(true)}
          startIcon={<FeatherIcon icon="edit" />}
        >
          {hasAddress
            ? t("organizationSettings.companyAddress.editAddress")
            : t("organizationSettings.companyAddress.addAddress")}
        </Button>
      </Box>
      {editAddressOpen && (
        <CompanyAddressEditor
          open={editAddressOpen}
          onClose={() => setEditAddressOpen(false)}
        />
      )}
    </>
  ) : null;
};

export default CompanyAddress;
